import config from "./../components/canvas/store/sqftConfig";
///todo sqft-reacet//import 'core-js/es/array';
import workspace from "./../components/canvas/core/workspace";
import line from "./../components/canvas/core/shapes/line";
import $ from "jquery";
import sqftConfig from "../components/canvas/store/sqftConfig";
import {getEdgeFeatures} from "./shapeHelper";
import {isPointInsidePolygon} from "../lib/pnpoly";
import LineCorner from "../components/canvas/core/shapes/lineHooks/lineCorner";
import {getMiterEdgeHeight, isMiterEdge, isWaterfallFeature} from "./featureHelper";


export const getUrlSQFTHashParam = (queryParam) => {
  let hash = window.location.hash.substr(1);
  hash = hash.replace('/sqft?', '');

  const hashParsed = hash.split('&').reduce(function (res, item) {
    let parts = item.split('=');
    res[parts[0]] = parts[1];
    return res;
  }, {});

  return hashParsed[queryParam];
}

export const isIphoneX = () => { // https://stackoverflow.com/questions/47226824/iphonex-and-notch-detection
  let iPhone = /iPhone/.test(navigator.userAgent) && !window.MSStream;
  let aspect = window.screen.width / window.screen.height;
  return !!(iPhone && aspect.toFixed(3) === "0.462")
};
export const isAndroid = () => {
  return navigator.userAgent && navigator.userAgent.toLowerCase().indexOf("android") > -1;
};
export const isChrome = () => {
  return !!navigator.userAgent.match('CriOS');
};
export const isIOSDevice = () => {
  return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
};
export const isIE = () => {
  return (window.navigator.userAgent.indexOf('MSIE ') > 0)
    || (!!window.MSInputMethodContext && !!document.documentMode)
    || (window.navigator.userAgent.indexOf('Trident/') > 0)
};
export const isEdge = () => {
  return window.navigator.userAgent.indexOf('Edge') > 0
};
export const isFirefox = () => navigator.userAgent.toLowerCase().indexOf("firefox") > -1;

export const hardCodeIsLowes = () => {
  const fabricatorId = getParamFromUrl("fabricatorId") || window.fabricatorId || document.kvConfig.userId || 137530; // master countertops2
  return fabricatorId === 139043 || window.location.href.includes("mdp_surfaces") || window.location.href.includes("lowes_")
};

export const getFontsize = () => {
  return config.measureUnit === "Imperial" ? config.workspace.fontSize : config.workspace.fontSizeMetric;
};

export const getFontsizeSmall = () => {
  return $(window).width() <= 1024 ? getFontsize() - 4 : getFontsize() - 4;
};

export const rotatePoint = (point, center, angle) => {
  angle = angle * (Math.PI/180); // Convert to radians
  const rotatedX = Math.cos(angle) * (point.x - center.x) - Math.sin(angle) * (point.y - center.y) + center.x;
  const rotatedY = Math.sin(angle) * (point.x - center.x) + Math.cos(angle) * (point.y - center.y) + center.y;

  return {x: rotatedX, y: rotatedY}
};

export const getPointDistance = (from, to) => {
  var pointDistance = Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2));
  return Math.round10(pointDistance, -3)
};

export const getClosestPoint = (point, points) => {
  return points.reduce((a, b) => getPointDistance(point, a) < getPointDistance(point, b) ? a : b);
};

export const get45CornerLegDistanceByHypotenuse = (hypotenuseDistance) => {
  return Math.sqrt(Math.pow(hypotenuseDistance, 2) / 2)
};

export const getMidPoint = (point1, point2) => {
  return {
    x: (point1.x + point2.x) / 2,
    y: (point1.y + point2.y) / 2
  };
};

export const getSectionPartPoint = (point1, point2, part) => {
  return {
    x: (point1.x + 1/part * point2.x) / (1 + 1/part),
    y: (point1.y + 1/part * point2.y) / (1 + 1/part)
  };
};

export const getParralelPoint = (pointA, pointB, distanceFromLine = 5) => {
  // pointA - closest to the needed point
  // pointB - far to the needed point
  const midPoint = getPointBetweenPoints(pointA, pointB, distanceFromLine);
  const x = pointA.x + (pointA.x - midPoint.x) * 2;
  const y = pointA.y + (pointA.y - midPoint.y) * 2;

  return {x, y}
};

export const getParallelPoints = (pointA, pointB, distanceFromLine = 5) => {
  let vector = {x: pointB.x - pointA.x, y: pointB.y - pointA.y}
  let len = Math.sqrt(Math.pow(vector.x, 2) + Math.pow(vector.y, 2));
  let ud = {x: vector.x / len, y: vector.y / len};
  //let perpendicularVector = {x: -ud.y, y: ud.x };

  let parallelPoint1 = {
    x: pointA.x - ud.y * distanceFromLine,
    y: pointA.y + ud.x * distanceFromLine
  };
  let parallelPoint2 = {
    x: parallelPoint1.x + vector.x,
    y: parallelPoint1.y + vector.y,
  };

  return [parallelPoint2, parallelPoint1];
};

export const getDistanceFromPointToLine = (x, y, x1, y1, x2, y2) => {
  let A = x - x1;
  let B = y - y1;
  let C = x2 - x1;
  let D = y2 - y1;

  let dot = A * C + B * D;
  let len_sq = C * C + D * D;
  let param = -1;
  if (len_sq !== 0) //in case of 0 length line
    param = dot / len_sq;

  let xx, yy;
  if (param < 0) {
    xx = x1;
    yy = y1;
  } else if (param > 1) {
    xx = x2;
    yy = y2;
  } else {
    xx = x1 + param * C;
    yy = y1 + param * D;
  }

  let dx = x - xx;
  let dy = y - yy;

  return Math.sqrt(dx * dx + dy * dy);
}

export const getDistanceFromPointToInfiniteLine = (x, y, x1, y1, x2, y2) => {
  return Math.abs((y2 - y1) * x - (x2 - x1) * y + x2 * y1 - y2 * x1) /
    Math.sqrt( Math.pow(y2 - y1, 2) + Math.pow(x2 - x1, 2))
}

/**
 * @param pointA closest to the needed point
 * @param pointB far to the needed point
 * @param distanceFromPointA
 * @param decimals
 * @return {{x: *, y: *}}
 */
export const getPointBetweenPoints = (pointA, pointB, distanceFromPointA = 5, decimals = null) => {
  // Calculate distance between pointA and pointB
  const distance = getPointDistance(pointA, pointB);
  const Xa = pointA.x;
  const Ya = pointA.y;
  const Xb = pointB.x;
  const Yb = pointB.y;

  // Calculate proportion k
  const k = distanceFromPointA / distance;
  let Xc = Xa + (Xb - Xa) * k;
  let Yc = Ya + (Yb - Ya) * k;

  // Check if decimals is not null and round if needed
  if (decimals !== null) {
    Xc = parseFloat(Math.round10(Xc, decimals));
    Yc = parseFloat(Math.round10(Yc, decimals));
  }

  return { x: Xc, y: Yc };
};

export const getPointField = (posX, posY, parent = workspace) => {
  let scale = workspace.getScale(),
    offset = parent.getOffset();

  return {
    x: (posX * scale) + offset.x,
    y: (posY * scale) + offset.y
  };
};

export const getPointOnWorkspace = (posX, posY, parent = workspace) => {
  let offset = parent.getOffset();

  return {
    x: posX + offset.x,
    y: posY + offset.y
  };
};

export const getMousePositionOnField = (mouseX, mouseY) => {
  let wPos = workspace.getPosition();
  let scale = config.scale;

  return {
    x: (mouseX + wPos.x) / scale,
    y: (mouseY + wPos.y) / scale
  };
};

export const getMousePositionOnShape = (mouseX, mouseY, shape) => {
  const pointPosOnShape = getMousePositionOnField(mouseX, mouseY, shape);
  const pos = shape.getPosition();
  return {
    x: pointPosOnShape.x - pos.x,
    y: pointPosOnShape.y - pos.y
  };
};

export const getPointPositionOnShape = (pointPosX, pointPosY, shape) => {
  const pos = shape.getPosition();
  return {
    x: pos.x + pointPosX,
    y: pos.y + pointPosY
  };
};

/**
 * Return the first two pairs which have the smallest distances
 * @param pointsA
 * @param pointsB
 * @return {*[]}
 */
export const findClosestPointPairs = (pointsA, pointsB) => {
  let pairs = [];

  // Find the closest point from pointsB for each point in pointsA
  pointsA.forEach(pointA => {
    let closestPoint = null;
    let minDistance = Number.MAX_VALUE;

    // Iterating over each point in pointsB
    pointsB.forEach(pointB => {
      let distance = getPointDistance(pointA, pointB);
      // Updating the closest point and minimum distance if a closer point is found
      if (distance < minDistance) {
        closestPoint = pointB;
        minDistance = distance;
      }
    });

    pairs.push({ pointA, pointB: closestPoint, distance: minDistance });
  });

  // Sorting the pairs by distance
  pairs.sort((a, b) => a.distance - b.distance);

  return pairs.slice(0, 2);
}

export const orientation = {
  VERTICAL: 0,
  HORIZONTAL: 1,
  NORTHWEST: 2,
  SOUTHEAST: 3,
  NORTHEAST: 4,
  SOUTHWEST: 5
};

export const getParamFromUrl = (name, url = window.location.href) => {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const numToLetter = (num) => {
  let mod = num % 26;
  let pow = num / 26 | 0;
  let out = mod ? String.fromCharCode(64 + mod) : (pow--, 'Z');

  return pow ? numToLetter(pow) + out : out;
};

export const letterToNum = (str) => {
  let out = 0,
    len = str.length,
    pos = len;

  while ((pos -= 1) > -1) {
    out += (str.charCodeAt(pos) - 64) * Math.pow(26, len - 1 - pos);
  }

  return out;
};

export const calculateHypotenuse = (a, b) => {
  return Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
}

//// CONVERT MEASURE UNIT START ////

export const mmToM = (mm) => {
  return Math.ceil10(mm / config.mmDivider, -2);
};

export const mm2ToM2 = (mm) => {
  return Math.ceil10(mm / config.mm2ToM2Divider, -2);
};

export const cmToInches = (cm) => {
  return Math.ceil10(cm / 2.54, -2);
};

export const mmToInches = (mm) => {
  return Math.ceil10(mm / 25.4, -3);
};

export const cmToMm = (cm) => {
  return Math.ceil10(cm * 10, -2);
};

export const inchesToMm = (totalInches, shouldCeil = true, shouldRound = false) => {
  if (shouldCeil) {
    return Math.ceil(totalInches * config.millimetersMultiplier);
  } else if (shouldRound) {
    return Math.round(totalInches * config.millimetersMultiplier);
  }
  return totalInches * config.millimetersMultiplier;
};

export const inchesToM = (totalInches) => {
  return Math.ceil10(totalInches * config.inchesToMMultiplier, -2);
};
export const inchesToLNFT = (totalInches) => {
  return Math.ceil10(totalInches * 0.08333, -2);
};
export const sqInchesToSqFoot = (totalInches) => {
  return Math.ceil10(totalInches / 144, -2);
};

export const sqInchesToMM2 = (inches) => {
  return Math.ceil10(inches * 645.16, -2);
};

export const sqInchesToM2 = (totalInches) => {
  return Math.ceil10(totalInches / 1550, -2);
};

export const sqftToMM2 = (length) => {
  return Math.ceil(length * config.sqftToMmMultiplier);
};

export const lnftToMM = (length) => {
  return Math.ceil(length * config.lnftToMmMultiplier);
};

export const sqftToM2 = (length) => {
  return Math.ceil10(length * config.sqftToM2Multiplier, -2);
};

export const getTransformedMeasureUnit = (value) => {
  return sqftConfig.measureUnit === "Metric"
    ? measureDistanceToInches(value).millimeters // ? distanceToMillimeters(inchesToMm(segment.length.value))
    : value;
}

//// CONVERT MEASURE UNIT END ////

//// MEASURE DISTANCE START ////

// Reduce a fraction by finding the Greatest Common Divisor and dividing by it.
const gcd = (a, b) => {
  if (b === 0) return a;
  return gcd(b, a % b);
};

const reduce = (numerator, denominator) => {
  const common = gcd(numerator, denominator);
  return [numerator / common, denominator / common];
};

export const measureDistanceToInches = (distance) => {
  let denom = 16;
  var total_segments = Math.ceil(distance * denom),
    // todo check if calculations are correct
    // millimeters = inchesToMm(distance),
    millimeters =  Math.round(distance * config.millimetersMultiplier),
    segmentDistance = total_segments / denom,
    fraction = total_segments % denom,
    rounded = Math.floor(segmentDistance),
    inches = rounded % 12,
    feet = (rounded - inches) / 12,
    reduced = [0,0],
    decimal = 0;

  if(fraction > 0) {
    reduced = reduce(fraction, denom);
  }

  if(reduced[0] !== 0 && reduced[1] !== 0) {
    decimal = Math.floor((reduced[0] * 100) / (reduced[1] * 100)) / 100;
  }

  return {
    feet: feet,
    inches: inches,
    millimeters: millimeters,
    rounded: rounded,
    reduced: reduced,
    decimal: decimal
  }
};

export const getSnappedPos = function(pos) {
  let scaledGridSize = sqftConfig.workspace.getScaledGridSize();
  let newX = Math.round(pos.x / scaledGridSize) * scaledGridSize;
  let newY = Math.round(pos.y / scaledGridSize) * scaledGridSize;
  return {
    x: newX,
    y: newY
  };
};

export const distanceToInches = (distance) => {
  var dist = measureDistanceToInches(distance),
    ret = "";

  if(dist.feet > 0)
    ret = dist.feet + "'";
  if(dist.inches > 0)
    ret += dist.inches + "\"";

  if(dist.reduced[0] > 0) {
    var fraction_text = dist.reduced[0] + "/" + dist.reduced[1];
    ret = ret.toString().substr(0, ret.length - 1) + " " + fraction_text + "\"";
    dist.rounded += " " + fraction_text;
  }

  ret = dist.rounded + "\"";

  return ret;
};

export const distanceToMillimeters = (distance) => {
  var dist = measureDistanceToInches(distance);

  return dist.millimeters + " mm";
};

/*
  * edge can be applied to line and to lineCorner
  */
export const getEdgeLength = (attachedTo) => {
  let lineBumpoutTotalHeight = 0;
  let lineCornerWidth = 0;
  let length = 0;
  if (attachedTo instanceof LineCorner) {
    switch (config.measureUnit) {
      case "Imperial": length += inchesToLNFT(attachedTo.getLength()); break;
      case "Metric": length += inchesToM(attachedTo.getLength()); break;
    }
  } else if (attachedTo instanceof line) {
    if (attachedTo.isWithBumpout()) {
      lineBumpoutTotalHeight = attachedTo.getLineBumpoutTotalHeight();
    }
    if (attachedTo.lineCorner) {
      lineCornerWidth += attachedTo.get45CornerLegDistance();
    }
    const prevLine = attachedTo.getParent().getPrevLine(attachedTo);
    if (prevLine.lineCorner) {
      lineCornerWidth += prevLine.get45CornerLegDistance();
    }
    if (config.measureUnit === "Imperial") {
      length = Math.round(( Math.sqrt(
        Math.pow(attachedTo.to.x - attachedTo.from.x, 2)
        +
        Math.pow(attachedTo.to.y - attachedTo.from.y, 2)
      ) + lineBumpoutTotalHeight - lineCornerWidth) / 12 * 100) / 100;
    } else {
      length = inchesToM(
        Math.abs(attachedTo.to.x - attachedTo.from.x + attachedTo.to.y - attachedTo.from.y)
        + lineBumpoutTotalHeight - lineCornerWidth
      )
    }
  }

  return length;
};

export const getEdgeArea = (line, length, featureId) => {
  let totalArea = 0;
  const navItems = getEdgeFeatures();
  let edge = navItems.find(edge => edge.part.dbFeature.id === featureId);
  // let edge = edges.edges.find(edge => edge.id === +img.dataset.id);
  // let edgeFeature = edges.getFeatureEdgeFilter(edge);

  if (!edge) {
    if (!workspace.isEdgeFeatureError) {
      console.log('edgeFeature not found', featureId);
      workspace.isEdgeFeatureError = true
    }

    return totalArea;
  }

  // 1.) additional area for waterfall edges
  if (isWaterfallFeature(edge.part.dbFeature.id)) { // && !isFeatureUnitUseEach(edge.part)
    switch (config.measureUnit) {
      case "Imperial": totalArea += length * config.waterfallImperialHeight; break;
      case "Metric": totalArea += length * config.waterfallMetricHeight; break;
    }
    // additional area for 40mm edges
  }

  // 2.) additional area for mitered edges (additional area for the mitered edge tool added separately)
  if (isMiterEdge(featureId) && !line.isWithMitered() ) {
    // additional area for 40mm edges
    const miterEdgeHeight = getMiterEdgeHeight(featureId);
    if (miterEdgeHeight) {
      totalArea += length * miterEdgeHeight
    }
  }

  //let edge40mmIds = edges.getEdgeFilterByValue("40mm Waterfall").map(({ id }) => id);
  //let is40mmEdge = edge40mmIds.filter(value => edgeFeature.includes(value)).length > 0;

  // else if (is40mmEdge) { // by text: edge.displayName.includes('40mm')
  //   switch (config.measureUnit) {
  //     //case "Imperial": totalArea += length * config.waterfallImperialHeight; break;
  //     case "Metric": totalArea += length * 40; break;
  //   }
  // }

  return totalArea;
}

export const getBacksplashArea = (backsplashValue, attachedTo) => {
  backsplashValue = config.measureUnit === "Imperial" ? +backsplashValue : mmToInches(+backsplashValue);
  const backsplashLength = sqInchesToSqFoot(getBacksplashLength(attachedTo));
  const backsplashArea = Math.round10(backsplashValue * backsplashLength, -2)

  return config.measureUnit === "Imperial" ? backsplashArea : sqftToM2(backsplashArea);
};

/*
  * backsplash can be applied to line and to lineCorner
  * return sqft
  */
export const getBacksplashLength = (attachedTo) => {
  let length = 0;
  let lineCornerWidth = 0;

  if (attachedTo instanceof LineCorner) {
    length += attachedTo.getLength();
  } else if(attachedTo instanceof line) {
    const prevLine = attachedTo.getParent().getPrevLine(attachedTo);
    let lineLength = attachedTo.getLineLength();

    if (attachedTo.isWithBumpout()) {
      lineLength += attachedTo.getLineBumpoutTotalHeight();
    }
    if (attachedTo.lineCorner) {
      lineCornerWidth += attachedTo.get45CornerLegDistance();
    }
    if (prevLine.lineCorner) {
      lineCornerWidth += prevLine.get45CornerLegDistance();
    }

    length += lineLength - lineCornerWidth;
  }

  return length;
};

//// MEASURE DISTANCE END ////

export const truncate = (source, size) => {
  let quot = '&quot;';
  if(source.slice(0, size - 1 + quot.length).includes(quot)) {
    size += quot.length - 1;
  }

  return source.length > size ? source.slice(0, size - 1) + "…" : source;
};

//// HTML ////

export const setStylesOnElement = (element, styles) => {
  Object.assign(element.style, styles);
};

export const getMinInArray = (array, attrib) => {
  return array.reduce(function(prev, curr) {
    return prev[attrib] < curr[attrib] ? prev : curr;
  });
};

export const getMaxInArray = (array, attrib) =>{
  return array.reduce(function(prev, curr) {
    return prev[attrib] < curr[attrib] ? prev : curr;
  });
};

/// SLAB ///

export const getGCD = function(a, b) {
  if (!b) {
    return a;
  }

  return getGCD(b, a % b);
};

export const getAspectRatio = function(height, width) {
  let heightGCD = getGCD(height, width);
  let aspectHeight = height / heightGCD;
  let aspectWidth = width / heightGCD;

  console.log("heightGCD", heightGCD);
  console.log("aspectHeight", aspectHeight);
  console.log("aspectWidth", aspectWidth);

  return {aspectHeight, aspectWidth, heightGCD};
};

/**
 * If shouldExtend is true this will always return point if segments are not parallel.
 * @param {{x: number, y: number}} point1
 * @param {{x: number, y: number}} point2
 * @param {{x: number, y: number}} point3
 * @param {{x: number, y: number}} point4
 * @param {boolean} isRounded
 * @param {boolean} shouldExtend
 * @return {{x: number, y: number}|null} new point on the line
 */
export const getIntersectCordsBetweenLines = (point1, point2, point3, point4, isRounded, shouldExtend = false) => {
  const points = [point1.x, point1.y, point2.x, point2.y, point3.x, point3.y, point4.x, point4.y];
  if (shouldExtend) {
    return getIntersectCordsWithExtendedSegments(...points);
  } else {
    return getIntersectCords(...points, isRounded)
  }

}

// line intercept math by Paul Bourke http://paulbourke.net/geometry/pointlineplane/
// Determine the intersection point of two line segments
// Return FALSE if the lines don't intersect
export const getIntersectCords = function(x1, y1, x2, y2, x3, y3, x4, y4, rounded) {

  // Check if none of the lines are of length 0
  if ((x1 === x2 && y1 === y2) || (x3 === x4 && y3 === y4)) {
    return false
  }
  let denominator = ((y4 - y3) * (x2 - x1) - (x4 - x3) * (y2 - y1));

  // Lines are parallel
  if (denominator === 0) {
    return false
  }

  let ua = ((x4 - x3) * (y1 - y3) - (y4 - y3) * (x1 - x3)) / denominator;
  let ub = ((x2 - x1) * (y1 - y3) - (y2 - y1) * (x1 - x3)) / denominator;

  // is the intersection along the segments
  if (ua < 0 || ua > 1 || ub < 0 || ub > 1) {
    return false
  }

  // Return a object with the x and y coordinates of the intersection
  let x = x1 + ua * (x2 - x1);
  let y = y1 + ua * (y2 - y1);
  if (rounded) {
    x = Math.round(x);
    y = Math.round(y);
  }

  return {x, y}
};

/**
 * We expand two segments and get their intersection point. This will always return point if segments are not parallel.
 * @param x1
 * @param y1
 * @param x2
 * @param y2
 * @param x3
 * @param y3
 * @param x4
 * @param y4
 * @return {{x: number, y: number}|null} new point on the line
 **/
const getIntersectCordsWithExtendedSegments = (x1, y1, x2, y2, x3, y3, x4, y4) => {
  const A1 = y2 - y1;
  const B1 = x1 - x2;
  const C1 = A1 * x1 + B1 * y1;

  const A2 = y4 - y3;
  const B2 = x3 - x4;
  const C2 = A2 * x3 + B2 * y3;

  const det = A1 * B2 - A2 * B1;

  if (det === 0) {
    return null;
  } else {
    const x = (B2 * C1 - B1 * C2) / det;
    const y = (A1 * C2 - A2 * C1) / det;
    return { x, y };
  }
};

/**
 * get new point on the beam which is at distant from the second point at a certain length distance
 * @param {{x: number, y: number}} point1
 * @param {{x: number, y: number}} point2
 * @param {number} distance
 * @return {{x: number, y: number}} new point on the line
 */
export const getPointOnTheLine = (point1, point2, distance) => {
  const length = getPointDistance(point1, point2);
  const k = 1 + distance / length;
  const x = parseFloat(point2.x) + k * (parseFloat(point1.x) - parseFloat(point2.x));
  const y = parseFloat(point2.y) + k * (parseFloat(point1.y) - parseFloat(point2.y));

  return {x, y}
}

/**
 * Determines whether a point is inside a shape or on its border.
 *
 * @param {Object} point - The point to check, with properties x and y.
 * @param {Object} shape - The shape object, which has a getLines method returning line segments.
 * @param {boolean} [includeBorder=false] - If true, the function also returns true when the point is on the border of the shape.
 * @returns {boolean} True if the point is inside the shape or on its border (depending on includeBorder), otherwise false.
 */
export const isPointInsideShape = (point, shape, includeBorder = false) => {
  let x = point.x, y = point.y;
  let inside = false;
  let shapeLines = shape.getLines(true);

  for (let i = 0, j = shapeLines.length - 1; i < shapeLines.length; j = i++) {
    const iPosition = getPointField(shapeLines[i].from.x, shapeLines[i].from.y, shapeLines[i]);
    const jPosition = getPointField(shapeLines[j].to.x, shapeLines[i].to.y, shapeLines[j]);

    let xi = iPosition.x, yi = iPosition.y;
    let xj = jPosition.x, yj = jPosition.y;

    // Check if the point is on the line segment
    if (includeBorder && isPointOnLine(point, {x: xi, y: yi}, {x: xj, y: yj})) {
      return true;
    }

    if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) {
      inside = !inside;
    }
  }

  return inside;
};

/**
 * Checks if a point is on a line segment defined by two points.
 *
 * @param {Object} pt - The point to check, with properties x and y.
 * @param {Object} linePt1 - The first point of the line segment, with properties x and y.
 * @param {Object} linePt2 - The second point of the line segment, with properties x and y.
 * @returns {boolean} True if the point is on the line segment, otherwise false.
 */
function isPointOnLine(pt, linePt1, linePt2) {
  const dxc = pt.x - linePt1.x;
  const dyc = pt.y - linePt1.y;
  const dxl = linePt2.x - linePt1.x;
  const dyl = linePt2.y - linePt1.y;

  const cross = dxc * dyl - dyc * dxl;
  if (cross !== 0) return false; // Point is not on the line

  // Check if the point is within the line segment bounds
  if (Math.abs(dxl) >= Math.abs(dyl))
    return dxl > 0 ? linePt1.x <= pt.x && pt.x <= linePt2.x : linePt2.x <= pt.x && pt.x <= linePt1.x;
  else
    return dyl > 0 ? linePt1.y <= pt.y && pt.y <= linePt2.y : linePt2.y <= pt.y && pt.y <= linePt1.y;
}

export const getAreaByShoelaceFormula = (lines) => {
  let area = 0;
  for (let i = 0; i < lines.length; i++) {
    area += lines[i].to.x * (lines[i + 1] ? lines[i + 1].to.y : lines[0].to.y );
    area -= lines[i].to.y * (lines[i + 1] ? lines[i + 1].to.x : lines[0].to.x );
  }

  return area / 2;
};

export const addDecimalToLength = (lineLength) => {
  let decimal = 0;
  if (lineLength.reduced.length) {
    if (lineLength.reduced[0] === 1 && lineLength.reduced[1] === 4) {
      decimal = 0.25;
    } else if (lineLength.reduced[0] === 1 && lineLength.reduced[1] === 2) {
      decimal = 0.5;
    } else if (lineLength.reduced[0] === 3 && lineLength.reduced[1] === 4) {
      decimal = 0.75;
    }
  }

  return lineLength.rounded + decimal
};

export const getAngleBetweenTwoPoints = (point1, point2) => {
  return Math.atan2(point2.y - point1.y, point2.x - point1.x) * 180 / Math.PI;
}

export const getAngleRelativeToTheHorizontalAxis = (point1, point2) => {
  let dx = point1.x - point2.x;
  let dy = point1.y - point2.y;

  return (Math.atan2(dy, dx) * 180 / Math.PI + 360) % 360;
}

export const getTanDeg = (deg) => {
  let rad = deg * Math.PI/180;
  return Math.tan(rad);
}

/**
 * return closest higher number in array than needle
 * @param {int} needle
 * @param {[int]} array
 * @return {*}
 */
export const getClosestHigherNumber = (needle, array) => {
  return array.reduce((prev, curr) => {
    if (curr <= needle) {
      return prev
    }
    if (prev === null) {
      return curr
    }
    return curr - needle < prev - needle ? curr : prev;
  }, null);
}

export const isDisabledInPopupWithParents = (item) => {
  if (item.isDisabledInPopup) {
    return true
  }
  if (item.getParent && item.getParent()) {
    return isDisabledInPopupWithParents(item.getParent());
  }

  return false
}

/**
 * Point 1,2,3 is a corner, where 2 is midpoint
 * we assume that distance between lines is more than minLineLength
 * @param shape
 * @param point1
 * @param point2
 * @param point3
 * @param {number} minLineLength
 */
export const isInnerCorner = (shape, point1, point2, point3, minLineLength = 25) => {
  const shapePoints = shape.getPointFieldArray();
  const closePoint1 = getPointOnTheLine(point2, point1, -minLineLength);
  const closePoint2 = getPointOnTheLine(point2, point3, -minLineLength);
  const midPoint = getMidPoint(closePoint1, closePoint2);

  // RenderFigures.renderCircle(closePoint1, 12,1, '#63b141');
  // RenderFigures.renderCircle(closePoint2, 12,1, '#63b141');
  // RenderFigures.renderCircle(midPoint, 10, 1);
  // console.log("midPoint", midPoint);
  // console.log("isPointInsidePolygon", isPointInsidePolygon(midPoint, shapePoints));
  // debugger // eslint-disable-line no-debugger
  return !isPointInsidePolygon(midPoint, shapePoints);
}

export const parseImperialFractionToDecimal = (input) => {
  const sanitizedInput = input.replace(/['"]/g, "");
  const [wholePart, fractionPart] = sanitizedInput.split(" ");

  let decimalValue = parseFloat(wholePart) || 0; // Default to 0 if no whole part

  // If there's a fraction part, convert it to decimal
  if (fractionPart && fractionPart.includes("/")) {
    const [numerator, denominator] = fractionPart.split("/").map(Number);
    if (denominator) {
      decimalValue += numerator / denominator;
    }
  }

  return decimalValue;
};

/**
 * Checks if a value is approximately equal to a target value within a specified tolerance.
 * @param {number} value - The value to check.
 * @param {number} target - The target value.
 * @param {number} tolerance - The tolerance allowed for approximation (default is 1).
 * @returns {boolean} True if the value is approximately equal to the target.
 */
export const isApproximatelyEqual = (value, target, tolerance = 1) => {
  return Math.abs(value - target) < tolerance;
};
